<template>
  <el-dialog
    title="修改"
    :visible.sync="dialogVisible"
    width="70%"
    @close="refreshEditSmallWeChatInfo"
  >
    <el-form label-width="120px">
      <el-form-item label="名称" required>
        <el-input
          v-model="editSmallWeChatInfo.name"
          placeholder="必填，请填写名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="支付密码" required>
        <el-input
          v-model="editSmallWeChatInfo.payPassword"
          placeholder="必填，请填写支付密码"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="商户ID" required>
        <el-input
          v-model="editSmallWeChatInfo.mchId"
          placeholder="必填，请填写商户ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户名称" required>
        <el-input
          v-model="editSmallWeChatInfo.mchName"
          placeholder="必填，请填写商户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户证书">
        <upload-file
          ref="uploadFile"
          namespace="editSmallWeChat"
          @notifyCert="handleCertUpload"
        ></upload-file>
      </el-form-item>
      <el-form-item label="描述">
        <el-input
          v-model="editSmallWeChatInfo.remarks"
          type="textarea"
          placeholder="选填，请填写描述信息"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="editSmallWeChat">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateSmallWeChat } from '@/api/goods/smallWeChatApi'
import { getShopId, getDict } from '@/api/shop/shopApi'
import UploadFile from '@/components/frame/uploadFile/uploadFile.vue'

export default {
  name: 'EditSmallWeChat',
  components: {
    UploadFile
  },
  data() {
    return {
      dialogVisible: false,
      editSmallWeChatInfo: {
        weChatId: '',
        wechatId: '',
        name: '',
        appId: '-1',
        appSecret: '-1',
        payPassword: '',
        createTime: '',
        objType: '',
        objId: '',
        mchId: '',
        mchName: '',
        remarks: '',
        objTypes: [],
        certPath: ''
      }
    }
  },
  methods: {
    open(params) {
      this.refreshEditSmallWeChatInfo()
      this.getDictData()
      Object.assign(this.editSmallWeChatInfo, params)
      this.editSmallWeChatInfo.appId = '-1'
      this.editSmallWeChatInfo.appSecret = '-1'
      this.dialogVisible = true
    },
    async getDictData() {
      try {
        const {data: objTypes } = await getDict('small_wechat', 'obj_type')
        this.editSmallWeChatInfo.objTypes = objTypes
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleCertUpload(param) {
      this.editSmallWeChatInfo.certPath = param.realFileName
    },
    editSmallWeChatValidate() {
      // 验证逻辑保持不变
      // ...
    },
    editSmallWeChat() {
      if (!this.editSmallWeChatValidate()) {
        this.$message.error(this.validateErrInfo)
        return
      }

      this.editSmallWeChatInfo.objId = getShopId()
      updateSmallWeChat(this.editSmallWeChatInfo)
        .then(response => {
          console.log(response)
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.$emit('listSmallWeChat')
        })
        .catch(error => {
          this.$message.error(error.message || '修改失败')
        })
    },
    refreshEditSmallWeChatInfo() {
      this.editSmallWeChatInfo = {
        weChatId: '',
        wechatId: '',
        name: '',
        appId: '',
        appSecret: '',
        payPassword: '',
        createTime: '',
        objType: '',
        objId: '',
        mchId: '',
        mchName: '',
        remarks: '',
        objTypes: [],
        certPath: ''
      }
      this.$refs.uploadFile.clearVedio()
    }
  }
}
</script>